import { apiClient } from './client';
import type { LoginRequest, LoginResponse, AdminUser } from '../types';

export const authApi = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>(
      '/admin/login',
      credentials
    );
    return response.data;
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/admin/logout');
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
  },

  verifyToken: async (): Promise<AdminUser> => {
    const response = await apiClient.get<AdminUser>('/admin/me');
    return response.data;
  },

  getCurrentUser: (): AdminUser | null => {
    const userJson = localStorage.getItem('admin_user');
    return userJson ? JSON.parse(userJson) : null;
  },

  saveAuth: (token: string, user: AdminUser): void => {
    localStorage.setItem('admin_token', token);
    localStorage.setItem('admin_user', JSON.stringify(user));
  }
};
